export const defaultWidthToReduce = 445;

export const defaultDualSidebarWidth = 945;
